import React from 'react';
import PropTypes from 'prop-types';
import { styled } from '@material-ui/core/styles';
import styles from './TimeElements.style';
import TagName from 'components/Shared/TagName';
import { useSelector } from 'react-redux';
import { ECOM_ONLY, MERCHANT_ONLY } from 'constants/constant';
import { buildBusinessName } from '../Preview.utils';

const MyHoverSpan = styled('span')({
	fontSize: '10px',
	color: '#6D6E71',
	backgroundColor: '#F9F9F9',
	borderRadius: '4px',
	width: '55px',
	overflow: 'hidden',
	whiteSpace: 'nowrap',
	verticalAlign: 'text-top',
	marginLeft: '8px'
});

const MyDiv = styled('span')({
	width: (P) => (P.hoverState ? '250px' : '260px'),
	display: 'inline-block'
});

function ItemDescription(props) {
	const classes = styles();
	const { businessName, checked, eComOnly = false, hoverState, merchantOnly = false } = props;
	const templateId = useSelector((state) => state.templateReducer.selectedTemplate);
	const pinnedAttributeCollection = useSelector((state) => state.previewReducer.pinnedAttribute);

	const pinnedAttributes = pinnedAttributeCollection[templateId] || { dimensions: [], metrics: [] };

	const getTagName = () => {
		const tags = [];
		if (eComOnly) {
			tags.push(ECOM_ONLY);
		}
		if (merchantOnly) {
			tags.push(MERCHANT_ONLY);
		}

		return tags;
	};

	const className = checked ? classes.hoverClass : classes.notCheckedClass;
	const tagComponent = checked ? (
		<MyHoverSpan>{getTagName().toString()}</MyHoverSpan>
	) : (
		<TagName value={getTagName()} />
	);

	let spanClassName = checked ? classes.hoverClass : classes.notCheckedClass;

	const pinnedMetrics = pinnedAttributes?.metrics || [];
	const pinnedDimensions = pinnedAttributes?.dimensions || [];
	const isPinned = [...pinnedMetrics, ...pinnedDimensions].includes(businessName);
	if (isPinned) {
		spanClassName = classes.pinnedItemDescription;
	}
	if (hoverState) {
		spanClassName = classes.hoverClass;
	}

	return eComOnly || merchantOnly ? (
		<MyDiv>
			<span className={className}>{businessName}</span>
			{tagComponent}
		</MyDiv>
	) : (
		<span className={spanClassName}>{buildBusinessName(businessName, templateId)}</span>
	);
}

ItemDescription.propTypes = {
	checked: PropTypes.bool,
	businessName: PropTypes.string,
	hover: PropTypes.bool,
	eComOnly: PropTypes.bool,
	merchantOnly: PropTypes.bool
};

export default ItemDescription;
